import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/FormSuggestions.module.css';

const FormSuggestions = ({
    suggestions = [],
    onSelect = () => {},
    ariaLabel = 'Suggestions',
    className = '',
}) => {
    if (!Array.isArray(suggestions) || suggestions.length === 0) return null;

    return (
        <div className={`${styles.container} ${className}`.trim()} aria-label={ariaLabel}>
            {suggestions.map((item, idx) => {
                const label = typeof item === 'string' ? item : (item?.label || '');
                const value = typeof item === 'string' ? item : (item?.value || item?.label || '');
                if (!label || !value) return null;
                return (
                    <button
                        key={`${label}-${idx}`}
                        type="button"
                        className={styles.suggestion}
                        onClick={() => onSelect(value)}
                        title={label}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};

FormSuggestions.propTypes = {
    suggestions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string,
        }),
    ])),
    onSelect: PropTypes.func,
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
};

export default memo(FormSuggestions);
